/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import { fetchDate } from "../../../utils/globleFunc";
import {
  Phone,
  Check,
  RefreshCw,
  Lock,
  Info,
  Plus,
  Key,
  Package,
  MessageCircle,
  Trash,
  ExternalLink,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationFoorcall({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const products = useSelector((state) => state.ProductsReducer);
  const { t } = useTranslation();

  const [data, setData] = useStoreFormDraft(store);

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();
    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000);
    return () => clearInterval(interval);
  }, []);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.confirmChat.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDChange = () => {
    setData({ ...data, foorcall: !data.foorcall });
  };

  const handleAddClick = () => {
    setData((previous) => ({
      ...previous,
      foorcallU: [...(previous.foorcallU || []), { user: "", products: "", telegram: "" }],
    }));
  };

  const handleDeleteClick = (indexToDelete) => {
    setData((previous) => ({
      ...previous,
      foorcallU: (previous.foorcallU || []).filter((_, index) => index !== indexToDelete),
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if Foorcall service is activated
    if (!data.foorcall) {
      await showAlert(
        "warning",
        t("servicePageActivation.foorcall.alerts.notActive.title"),
        t("servicePageActivation.foorcall.alerts.notActive.text")
      );
      return;
    }

    // Validate inputs
    if (data.foorcall && (!data.foorcallU || data.foorcallU.length === 0)) {
      await showAlert(
        "warning",
        t("servicePageActivation.foorcall.alerts.missingKey.title"),
        t("servicePageActivation.foorcall.alerts.missingKey.text")
      );
      return;
    }

    if (data.foorcall && data.foorcallU) {
      for (let i = 0; i < data.foorcallU.length; i++) {
        const item = data.foorcallU[i];
        if (!item.user || !item.products) {
          await showAlert(
            "warning",
            t("servicePageActivation.foorcall.alerts.missingEntry.title"),
            t("servicePageActivation.foorcall.alerts.missingEntry.text", { index: i + 1 })
          );
          return;
        }
      }
    }

    try {
      setLoading(true);
      apicache(account, products);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);

      await showAlert("success", t("servicePageActivation.foorcall.alerts.saveSuccess.title"));
      close();
    } catch (error) {
      setLoading(false);

      await showAlert(
        "error",
        t("servicePageActivation.foorcall.alerts.saveError.title"),
        t("servicePageActivation.foorcall.alerts.saveError.text")
      );

      console.error("Error saving Foorcall settings:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.foorcall.alerts.paidFeature.title"),
      t("servicePageActivation.foorcall.alerts.paidFeature.text"),
      true,
      t("servicePageActivation.foorcall.alerts.paidFeature.confirmButton")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  // If feature is locked, show lock screen
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] text-center dark:!bg-[#181819] dark:!border-[#3c3a3d]">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center dark:!bg-[#2a2a2a]">
                <Lock size={36} className="text-yellow-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] mb-3">
              {t("servicePageActivation.foorcall.lockedTitle")}
            </h3>
            <p className="text-gray-600 dark:!text-gray-400 mb-6 max-w-md mx-auto">
              {t("servicePageActivation.foorcall.lockedDescription")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.foorcall.subscribeButton")}
            </button>
          </div>
        </div>
      </div>

    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6"  >
      <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
            <Phone className="ml-2" size={20} />
            {t("servicePageActivation.foorcall.title")}
          </h3>
          <p className="text-gray-600 dark:!text-gray-400 mb-4">
            {t("servicePageActivation.foorcall.description")}
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 rounded-lg border border-blue-200 p-4 flex mb-6 dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]">
            <Info size={20} className="text-blue-500 ml-2 flex-shrink-0 mt-1 dark:!text-blue-400" />
            <div>
              <p className="font-medium text-blue-800 dark:!text-blue-400 mb-1">
                {t("servicePageActivation.foorcall.infoTitle")}
              </p>
              <p className="text-blue-700 dark:!text-gray-300 text-sm">
                {t("servicePageActivation.foorcall.infoDescription")}{" "}
                <a
                  href="https://admin.foorcall.com/settings/settingApi"
                  className="text-blue-600 font-medium hover:text-blue-800 dark:!text-blue-400 underline inline-flex items-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("servicePageActivation.foorcall.infoLink")}
                  <ExternalLink size={14} className="mr-1" />
                </a>
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <label className="block text-sm font-medium text-[#9e68ba] mb-4">
              {t("servicePageActivation.foorcall.toggleLabel")}
            </label>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${data.foorcall
                  ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:hover:!bg-[#2a2a2a]"
                }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input
                  type="checkbox"
                  checked={data.foorcall}
                  onChange={() => { }}
                  className="hidden"
                  id="toggle"
                />
                <label
                  htmlFor="toggle"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${data.foorcall ? "bg-purple-400" : ""
                    }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${data.foorcall ? "rtl:-translate-x-6 ltr:translate-x-6" : "translate-x-0"
                      }`}
                  />
                </label>
              </div>
              <div>
                <p className="font-medium dark:!text-gray-200">
                  {data.foorcall
                    ? t("servicePageActivation.foorcall.toggleOnTitle")
                    : t("servicePageActivation.foorcall.toggleOffTitle")}
                </p>
                <p className="text-sm text-gray-500 dark:!text-gray-400">
                  {data.foorcall
                    ? t("servicePageActivation.foorcall.toggleOnDesc")
                    : t("servicePageActivation.foorcall.toggleOffDesc")}
                </p>
              </div>
            </div>
          </div>

          {/* API Key Entries */}
          {data.foorcall && (
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <h4 className="font-medium text-lg text-[#9e68ba]">
                  {t("servicePageActivation.foorcall.addedKeysTitle")}
                </h4>
                <button
                  type="button"
                  onClick={handleAddClick}
                  disabled={data.foorcallU && data.foorcallU.length >= 5}
                  className={`bg-[#9b59bf] hover:bg-[#814a9f] text-white px-3 py-2 rounded-lg text-sm flex items-center transition-colors ${data.foorcallU && data.foorcallU.length >= 5
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                    }`}
                >
                  <Plus size={16} className="ml-1" />
                  {t("servicePageActivation.foorcall.addKeyButton")}
                </button>
              </div>

              {(!data.foorcallU || data.foorcallU.length === 0) && (
                <div className="text-center py-8 border border-dashed border-gray-300 rounded-lg bg-gray-50 dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]">
                  <Phone size={40} className="mx-auto text-gray-400 mb-2 dark:!text-gray-500" />
                  <p className="text-gray-500 dark:!text-gray-400">
                    {t("servicePageActivation.foorcall.emptyStateTitle")}
                  </p>
                  <p className="text-gray-500 text-sm dark:!text-gray-400">
                    {t("servicePageActivation.foorcall.emptyStateDesc")}
                  </p>
                </div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {Array.isArray(data.foorcallU) &&
                  data.foorcallU.map((item, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]"
                    >
                      <div className="flex justify-between items-center mb-3">
                        <h5 className="font-medium text-gray-700 dark:!text-gray-200">
                          {t("servicePageActivation.foorcall.apiKeyLabel")} #{index + 1}
                        </h5>
                        <button
                          type="button"
                          onClick={() => handleDeleteClick(index)}
                          className="text-red-500 hover:text-red-700 p-1 rounded-full hover:bg-red-50 dark:hover:!bg-[#3c3a3d] transition-colors"
                        >
                          <Trash size={16} />
                        </button>
                      </div>

                      <div className="space-y-3">
                        {/* API Key Input */}
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1 dark:!text-gray-400">
                            {t("servicePageActivation.foorcall.apiKeyPlaceholder")}
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              className="w-full p-2 pr-9 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-purple-200 text-sm dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-200 dark:placeholder-gray-500"
                              placeholder={t("servicePageActivation.foorcall.apiKeyPlaceholder")}
                              value={item.user || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setData((previous) => ({
                                  ...previous,
                                  foorcallU: previous.foorcallU.map((entry, i) =>
                                    i === index ? { ...entry, user: value } : entry),
                                }));
                              }}
                            />
                          </div>
                        </div>

                        {/* Product Selection */}
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1 dark:!text-gray-400">
                            {t("servicePageActivation.foorcall.productLabel")}
                          </label>
                          <div className="relative">
                            <select
                              className="w-full p-2 pr-9 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-purple-200 text-sm appearance-none bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-200"
                              value={item.products || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setData((previous) => ({
                                  ...previous,
                                  foorcallU: previous.foorcallU.map((entry, i) =>
                                    i === index ? { ...entry, products: value } : entry),
                                }));
                              }}
                            >
                              <option value="" disabled>
                                {t("servicePageActivation.foorcall.productPlaceholder")}
                              </option>
                              <option value="كل المنتجات">
                                {t("servicePageActivation.foorcall.allProducts")}
                              </option>
                              {products.map((product, idx) => (
                                <option key={idx} value={product.id}>
                                  {product.name}
                                </option>
                              ))}
                            </select>
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                              <svg
                                className="w-4 h-4 text-gray-400 dark:!text-gray-500"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>

                        {/* Telegram ID Input */}
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1 dark:!text-gray-400">
                            {t("servicePageActivation.foorcall.telegramLabel")}
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              className="w-full p-2 pr-9 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-purple-200 text-sm dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-200 dark:placeholder-gray-500"
                              placeholder={t("servicePageActivation.foorcall.telegramPlaceholder")}
                              value={item.telegram || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setData((previous) => ({
                                  ...previous,
                                  foorcallU: previous.foorcallU.map((entry, i) =>
                                    i === index ? { ...entry, telegram: value } : entry),
                                }));
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              {data.foorcallU && data.foorcallU.length >= 5 && (
                <p className="text-yellow-600 text-sm flex items-center dark:!text-yellow-400">
                  <Info size={16} className="ml-1" />
                  {t("servicePageActivation.foorcall.maxKeysWarning")}
                </p>
              )}
            </div>
          )}

          {/* Tips Section */}
          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-100 dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]">
            <h4 className="font-medium text-lg text-yellow-800 mb-2 flex items-center dark:!text-yellow-400">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.foorcall.tipsTitle")}
            </h4>
            <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-300">
              <li>{t("servicePageActivation.foorcall.tip1")} </li>
              <li>{t("servicePageActivation.foorcall.tip2")}</li>
              <li>{t("servicePageActivation.foorcall.tip3")}</li>
              <li>{t("servicePageActivation.foorcall.tip4")}</li>
            </ul>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center ${loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {t("servicePageActivation.foorcall.saving")}
              </>
            ) : (
              <>
                <Check className="ml-2" size={18} />
                {t("servicePageActivation.foorcall.saveButton")}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
